export interface FolderStatusSummary {
  completed: number;
  failed: number;
  pending: number;
  in_progress: number;
  unsupported: number;
}

export interface FolderNode {
  path: string;
  name: string;
  file_count: number;
  status_summary: FolderStatusSummary;
  children: FolderNode[];
}

export interface FolderTreeResponse {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  organization_id: string;
  root_folders: FolderNode[];
}

export interface FileStatusModel {
  mongodb_document_id: string;
  file_id: string;
  file_name: string;
  original_file_name?: string | null;
  timestamp_ms: number;
  organization_id: string;
  user_id: string;
  source_type: 's3' | string;
  upload_status: string;
  ingest_status: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string | null;
  status_history: Array<Record<string, unknown>>;
  sharepoint_item_path?: string | null;
  sharepoint_web_url?: string | null;
  sharepoint_created_at?: string | null;
  sharepoint_author?: string | null;
  sharepoint_last_modified_by?: string | null;
}

export interface FileStatusList {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  total_count: number;
  paginated_count: number;
  skip: number;
  limit: number;
  file_statuses: FileStatusModel[];
}

export enum IngestStatus {
  FAILED = 'Failed',
  IN_PROGRESS = 'In Progress',
  COMPLETED = 'Completed',
  PENDING = 'Pending',
}

export interface StatusSummaryResponse {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  total_files: number;
  by_ingest_status: Record<IngestStatus, number>;
  by_upload_status: Record<string, number>;
  last_sync?: string | null;
  files_last_24h: number;
}

export interface SyncRunModel {
  mongodb_document_id: string;
  organization_id: string;
  drive_id: string;
  drive_name: string;
  status: 'ok' | 'error' | 'in_progress' | string;
  timestamp: string;
  duration_seconds: number;
  files_seen: number;
  files_skipped: number;
  files_downloaded: number;
  errors: number;
  error_message?: string | null;
}

export interface SyncRunListResponse {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  total_count: number;
  paginated_count: number;
  skip: number;
  limit: number;
  sync_runs: SyncRunModel[];
}

export interface SyncTriggerResponse {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  run_id: string;
}

export interface SharepointHealthResponse {
  status: 'success' | 'error' | 'partial_failure' | 'info';
  organization_id: string;
  is_healthy: boolean;
  message: string;
  drive_id?: string | null;
  drive_name?: string | null;
  duration_seconds?: number | null;
}

export default {} as const;
